import {styled, clsx} from 'external/material'

import {inViewer} from 'settings'

import { centerVertically } from 'utils/style'
import {viewerGuard, subdomainLink} from 'utils/url'
import {logLessonAccess} from 'utils/lesson'

import {DownloadIcon, SquareArrowUpRightIcon} from 'resources/icons'


const StyledDashboardActivityItemDownload = styled('div')(dashboardActivityItemLinkStyles)

export default function DashboardActivityItemDownload(props) {

    const {hasEpl, type, downloaded} = props

    
    return(<StyledDashboardActivityItemDownload className={clsx(type, downloaded ? 'view' : 'download')}>
                {hasEpl && inViewer && downloaded && (
                    <a className={clsx("link", "view")} href={`//downloads/${props.lesson}`}>
                        <div className="icon-container">
                            <SquareArrowUpRightIcon fill="#fff" height={20} />
                        </div>
                    </a>
                )} 
                {hasEpl && inViewer && !downloaded && (
                    <a
                      className={clsx("link", "download")}
                      onClick={logLessonAccess('download', {...props, id: props.lesson})}
                      {...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'download', `?lesson=${props.lesson}`)})}
                    >
                    <div className="icon-container">
                        <DownloadIcon fill="#2c75bd" width={16} />
                    </div>
                </a>)}
        </StyledDashboardActivityItemDownload>
   )
}

function dashboardActivityItemLinkStyles(){
    return {
        flexShrink: 0,
        padding: 0,
        ...centerVertically,
        textAlign: 'center',
        borderRadius: 10,
        cursor: 'pointer',
        '&.download': {
            width: 65,
            border: 'solid 1px #d4d4d4',
            borderRadius: 10,
        },
        '&.view': {
            padding: '4px 0 2px 0', 
            flexGrow: 1,
            backgroundColor: '#639fe4',
        },
        '& .iconContainer': {
            display: 'flex',
            justifyContent: 'center',
        },
    }
}
